// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/admin/img/icons/checked.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/admin/img/icons/time.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cd-add-new-product-title {
    border: none !important;
}
.cd-add-new-product-title:focus {
    border: none !important;
    box-shadow: none !important;
}
.ck-balloon-panel {
    display: none !important;
}
.easycommerce .ck.ck-editor__top {
    border: 1px solid var(--color-ec-border) !important;
}
.easycommerce .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content {
    border: none;
}
.easycommerce .ck.ck-editor__main {
    margin-top: 15px;
}
.easycommerce .ck.ck-content {
    min-height: 399px;
    padding: 24px;
}
.easycommerce .ck .ck-placeholder {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}
.easycommerce .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
    border: 1px solid var(--color-ec-border) !important;
}
.easycommerce .ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
    padding: 15px;
}
.easycommerce .easycommerce-permalink-input {
    width: 190px;
    padding: 5px 5px 5px 0;
    border-top-width: 0;
    border-left-width: 0;
    border-right-width: 0;
    border-bottom: 1px solid #d9d9d9;
    border-radius: 0 !important;
    line-height: 16px !important;
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-addnew_cat-input {
    height: 48px;
    border: 1px solid var(--color-ec-border) !important;
    padding: 7px 20px !important;
    font-size: 16px;
    border-radius: 8px;
}
.easycommerce .easycommerce-addnew_cat-input:hover {
    border: 1px solid var(--color-ec-secondary) !important;
}
.easycommerce .easycommerce-addnew_cat-input:focus {
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-secondary) !important;
    border-color: var(--color-ec-primary) !important;
    font-size: 16px;
}
.easycommerce .easycommerce-permalink-input:focus {
    border-top-width: 0;
    border-left-width: 0;
    border-right-width: 0;
    border-bottom: 1px solid #d9d9d9 !important;
    border-radius: 0 !important;
    box-shadow: none;
}
.easycommerce .easycommerce-input-checkoutbox {
    position: relative;
    margin: unset !important;
    width: 20px;
    height: 20px;
    border-color: #7F7F98;
    box-shadow: none;
}

.easycommerce .easycommerce-input-checkoutbox.easycommerce-thumbnail-checkbox {
    width: 30px;
}
.easycommerce .easycommerce-input-checkoutbox:checked {
    background-color: var(--color-ec-primary);
    border: none;
    box-shadow: none;
}
.easycommerce
    .easycommerce-input-checkoutbox.easycommerce-thumbnail-checkbox:checked {
    background-color: #009d68;
    border: 1px solid #009d68;
}
.easycommerce .easycommerce-input-checkoutbox:focus {
    box-shadow: none;
    outline: none;
    border-color: #7F7F98;
}
.easycommerce .easycommerce-input-checkoutbox:checked::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin: unset;
    width: auto;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.easycommerce .easycommerce-parent-category-select {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 16px;
    color: var(--color-ec-body);
    padding: 16px;
    background-color: #fff;
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
}
.easycommerce .easycommerce-parent-category-select:hover {
    color: var(--color-ec-body);
    border: 1px solid var(--color-ec-secondary);
}
.easycommerce .easycommerce-parent-category-select:focus {
    color: var(--color-ec-body);
    border: 1px solid var(--color-ec-primary);
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-secondary) !important;
    outline: none;
}
.easycommerce .easycommerce-attributes-row input {
    border: none !important;
    border-radius: 0;
}
.easycommerce .easycommerce-attributes-row input:focus {
    box-shadow: none;
    border-color: var(--color-ec-border);
}
.easycommerce .easycommerce-attributes-row .easycommerce-attribute-field {
    border: 1px solid var(--color-ec-border) !important;
    border-right: none !important;
    padding: 15px;
    border-radius: 4px 0 0 4px;
    min-height: 56px;
}
.easycommerce-attributes-row button:hover svg path {
    transition: 0.3s all ease;
    fill: #ff3a52;
}
.easycommerce .easycommerce-attribute-item-cross-button:hover svg path {
    fill: var(--color-ec-body);
}
.easycommerce-pricing-action-btn-details {
    display: none;
}
.easycommerce-pricing-action-btn-details::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -10px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid var(--color-ec-body);
    clear: both;
}
.easycommerce-pricing-action-btn:hover
    .easycommerce-pricing-action-btn-details {
    transition: 0.3s all ease;
    display: block;
}
.easycommerce-product-prices select {
    width: 100%;
    height: 48px;
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
    color: var(--color-ec-placeholder);
    font-size: 14px;
    line-height: 20px;
    font-family: "Inter", "sans-serif";
    transition: 0.3s all ease-in-out;
}
.easycommerce-product-prices select:hover {
    color: var(--color-ec-body);
    box-shadow: none;
    outline: none;
    border-color: var(--color-ec-body);
}
.easycommerce-product-prices select:focus {
    color: var(--color-ec-body);
    border-color: var(--color-ec-primary);
    box-shadow: none;
    outline: none;
}
.easycommerce-product-prices select:hover::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce-product-prices select:hover::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce-product-prices input {
    border: 1px solid var(--color-ec-border);
    border-radius: 4px;
    padding: 10px;
    color: var(--color-ec-body);
    font-size: 16px;
    font-family: "Inter", "sans-serif";
    transition: 0.3s all ease-in-out;
}
.easycommerce-product-prices input::-moz-placeholder {
    color: var(--color-ec-placeholder);
    font-size: 16px;
}
.easycommerce-product-prices input::placeholder {
    color: var(--color-ec-placeholder);
    font-size: 16px;
}
.easycommerce-product-prices input:focus {
    box-shadow: none;
    border-color: var(--color-ec-border);
}
.easycommerce-product-prices label input {
    margin-left: 6px;
}
.easycommerce .easycommerce-physical-product-measurement-field {
    display: flex;
    border-radius: 8px;
}
.easycommerce .easycommerce-physical-product-measurement-field input {
    border: none;
    width: 100%;
    min-height: 48px;
    color: var(--color-ec-body);
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    background-color: transparent;
}
.easycommerce
    .easycommerce-physical-product-measurement-field
    input::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce
    .easycommerce-physical-product-measurement-field
    input::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-physical-product-measurement-field input:focus,
.easycommerce .easycommerce-physical-product-measurement-field select:focus {
    outline: none;
    box-shadow: none;
    border: none;
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-physical-product-measurement-field select:hover {
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-physical-product-measurement-field select {
    width: 110px;
    border: none;
    font-size: 12px;
    min-height: 48px;
    border-left: 1px solid var(--color-ec-border);
    background-color: transparent;
}
.easycommerce .easycommerce-physical-product-measurement-field select:focus {
    border-left: 1px solid var(--color-ec-border);
}
.easycommerce .easycommerce-shipping select {
    max-width: 100%;
    min-height: 48px;
    color: var(--color-ec-body);
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    border: 1px solid var(--color-ec-border);
}
.easycommerce .easycommerce-shipping select:focus {
    border-color: var(--color-ec-border);
    box-shadow: none;
    outline: none;
}
.easycommerce .easycommerce-digital-product-meta-info input {
    width: 70px;
    height: 38px;
    background: #f8f8f8;
    border: 1px solid var(--color-ec-border);
    padding: 6px 10px;
    color: var(--color-ec-body);
    line-height: 26px;
    font-weight: 400;
    font-size: 16px;
}
.easycommerce .easycommerce-digital-product-meta-info select {
    width: 101px;
    height: 38px;
    background-color: #f8f8f8;
    border: 1px solid var(--color-ec-border);
    padding: 6px 10px;
    color: var(--color-ec-body);
    line-height: 26px;
    font-weight: 400;
    font-size: 16px;
}
.easycommerce .easycommerce-product-title {
    width: 100%;
    padding: 5px;
    border-radius: 4px;
    border: 2px dashed var(--color-ec-border);
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    font-family: "Inter", "sans-serif";
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-product-title::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-product-title::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-input:focus {
    border-color: var(--color-ec-border);
    box-shadow: none;
    outline: none;
}
.easycommerce .easycommerce-pricingplan-title-field {
    width: calc(100% - 76px);
    border: none !important;
    padding: 10px 0;
    font-size: 17px;
    line-height: 26px;
    font-weight: 600;
    font-family: "Inter", "sans-serif";
}
.easycommerce .easycommerce-pricingplan-title-field::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-pricingplan-title-field::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-choose-template-select-field {
    max-width: 100%;
    border: 1px solid var(--color-ec-border);
    padding: 10px;
    font-size: 16px;
    line-height: 26px;
    font-family: "Inter", "sans-serif";
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-choose-template-select-field:focus {
    border-color: var(--color-ec-border);
    outline: 0;
    box-shadow: none;
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-choose-template-select-field:hover {
    color: var(--color-ec-placeholder);
}

.easycommerce .easycommerce-switch {
    position: relative;
    display: inline-block;
    width: 55px;
    height: 25px;
}

.easycommerce .easycommerce-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.easycommerce .easycommerce-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
}

.easycommerce .easycommerce-slider:before {
    position: absolute;
    content: "";
    height: 19px;
    width: 19px;
    left: 3px;
    top: 3px;
    background-color: white;
    transition: 0.4s;
}

.easycommerce .easycommerce-switch input:checked + .easycommerce-slider {
    background-color: #7351FD;
}

.easycommerce .easycommerce-switch input:checked + .easycommerce-slider:before {
    transform: translateX(30px);
}
.easycommerce
    .easycommerce-product-gallery-image-delete
    .easycommerce-image-delete-icon-default {
    display: block;
}
.easycommerce
    .easycommerce-product-gallery-image-delete
    .easycommerce-image-delete-icon-hover {
    display: none;
}
.easycommerce
    .easycommerce-product-gallery-image-delete:hover
    .easycommerce-image-delete-icon-default {
    display: none;
}
.easycommerce
    .easycommerce-product-gallery-image-delete:hover
    .easycommerce-image-delete-icon-hover {
    display: block;
}

/* Rounded sliders */
.easycommerce .easycommerce-slider.easycommerce-round {
    border-radius: 34px;
}
.easycommerce .easycommerce-slider.easycommerce-slider:before {
    border-radius: 50%;
}
.easycommerce .mce-tinymce .mce-container-body .mce-edit-area iframe {
    min-height: 450px !important;
}
.easycommerce .mce-tinymce .mce-container.mce-menubar.mce-toolbar.mce-first,
.easycommerce
    .mce-tinymce
    .mce-branding.mce-widget.mce-label.mce-flow-layout-item.mce-last {
    display: none !important;
}

/* Custom Input Fields Styles */
.easycommerce .easycommerce-input-type-radio {
    margin: 0;
    border: 1px solid #dbdbdb;

}
.easycommerce .easycommerce-input-type-radio:checked,
.easycommerce .easycommerce-input-type-radio.checked {
    border: 1px solid var(--color-ec-primary);
    box-shadow: none;
}
.easycommerce .easycommerce-input-type-radio:checked::before,
.easycommerce .easycommerce-input-type-radio.checked::before {
    content: ' ';
    background-color: var(--color-ec-primary);
    border-radius: 50%;
    width: .5rem;
    height: .5rem;
    margin: .1875rem;
    line-height: 1.14285714;
    float: left;
    display: inline-block;
    vertical-align: middle;
}
.easycommerce .easycommerce-input-type-select {
    width: 100%;
    padding: 10px;
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
    color: var(--color-ec-body);
    font-family: "Inter", "sans-serif";
    font-size: 16px;
    line-height: 26px;
    box-shadow: none;
    transition: 0.3s all ease-in-out;
}
.easycommerce .easycommerce-input-type-select:hover {
    border-color: var(--color-ec-secondary);
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-input-type-select::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-input-type-select::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce .easycommerce-input-type-select:focus {
    color: var(--color-ec-body) !important;
    border-color: var(--color-ec-primary);
    outline: none;
    box-shadow: none;
}
.easycommerce
    .easycommerce-product-publish-data-and-time
    .react-datepicker-wrapper {
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
}
.easycommerce
    .easycommerce-product-publish-data-and-time
    .react-datepicker__input-container
    input:first-child {
    border: none;
    position: relative;
    z-index: 2;
    background: transparent;
    color: var(--color-ec-placeholder);
    font-size: 14px;
    line-height: 16px;
    font-family: "Inter", "sans-serif";
    padding-left: 10px;
    padding-right: 40px;
}
.easycommerce
    .easycommerce-product-publish-data-and-time
    .react-datepicker__input-container::after {
    position: absolute;
    content: "";
    top: 3px;
    right: 10px;
    width: 18px;
    height: 21px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    z-index: 1;
}
.easycommerce .easycommerce-product-publish-data-and-time input:focus {
    outline: none;
    box-shadow: none;
    border: none;
}
.easycommerce
    .easycommerce-product-publish-data-and-time
    input.react-datepicker-time__input {
    border: 1px solid #000;
    color: #000;
}

@media only screen and (max-width: 1280px) {
    .easycommerce .easycommerce-switch {
        width: 38px;
        height: 20px;
    }
    .easycommerce .easycommerce-slider:before {
        height: 15px;
        width: 15px;
    }
    .easycommerce .easycommerce-switch input:checked + .easycommerce-slider:before {
        transform: translateX(17px);
    }
}`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/css/add-product.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,mDAAmD;AACvD;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,mDAAmD;AACvD;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,gCAAgC;IAChC,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,mDAAmD;IACnD,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,sDAAsD;AAC1D;AACA;IACI,kEAAkE;IAClE,gDAAgD;IAChD,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,2CAA2C;IAC3C,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;AACA;IACI,yCAAyC;IACzC,YAAY;IACZ,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,gDAA4D;IAC5D,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;AACA;IACI,2BAA2B;IAC3B,yCAAyC;IACzC,kEAAkE;IAClE,aAAa;AACjB;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,mDAAmD;IACnD,6BAA6B;IAC7B,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,2CAA2C;IAC3C,WAAW;AACf;AACA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,gCAAgC;AACpC;AACA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,kCAAkC;AACtC;AACA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,kCAAkC;AACtC;AAFA;IACI,kCAAkC;AACtC;AACA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,kCAAkC;IAClC,gCAAgC;AACpC;AACA;IACI,kCAAkC;IAClC,eAAe;AACnB;AAHA;IACI,kCAAkC;IAClC,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;;;IAGI,kCAAkC;AACtC;AAJA;;;IAGI,kCAAkC;AACtC;AACA;;IAEI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,6CAA6C;IAC7C,6BAA6B;AACjC;AACA;IACI,6CAA6C;AACjD;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;AAC5C;AACA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,wCAAwC;IACxC,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,2BAA2B;AAC/B;AACA;IACI,kCAAkC;AACtC;AAFA;IACI,kCAAkC;AACtC;AACA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AAFA;IACI,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,wCAAwC;IACxC,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,kCAAkC;AACtC;AACA;IACI,oCAAoC;IACpC,UAAU;IACV,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,QAAQ;IACR,uBAAuB;IAEvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IAGI,2BAA2B;AAC/B;AACA;;;IAGI,cAAc;AAClB;AACA;;;IAGI,aAAa;AACjB;AACA;;;IAGI,aAAa;AACjB;AACA;;;IAGI,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,4BAA4B;AAChC;AACA;;;;IAII,wBAAwB;AAC5B;;AAEA,+BAA+B;AAC/B;IACI,SAAS;IACT,yBAAyB;;AAE7B;AACA;;IAEI,yCAAyC;IACzC,gBAAgB;AACpB;AACA;;IAEI,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,2BAA2B;IAC3B,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,uCAAuC;IACvC,2BAA2B;AAC/B;AACA;IACI,kCAAkC;AACtC;AAFA;IACI,kCAAkC;AACtC;AACA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,aAAa;IACb,gBAAgB;AACpB;AACA;;;IAGI,wCAAwC;IACxC,kBAAkB;AACtB;AACA;;;;IAII,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;;IAGI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yDAAkE;IAClE,UAAU;AACd;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;;;IAGI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".cd-add-new-product-title {\n    border: none !important;\n}\n.cd-add-new-product-title:focus {\n    border: none !important;\n    box-shadow: none !important;\n}\n.ck-balloon-panel {\n    display: none !important;\n}\n.easycommerce .ck.ck-editor__top {\n    border: 1px solid var(--color-ec-border) !important;\n}\n.easycommerce .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content {\n    border: none;\n}\n.easycommerce .ck.ck-editor__main {\n    margin-top: 15px;\n}\n.easycommerce .ck.ck-content {\n    min-height: 399px;\n    padding: 24px;\n}\n.easycommerce .ck .ck-placeholder {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n.easycommerce .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n    border: 1px solid var(--color-ec-border) !important;\n}\n.easycommerce .ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {\n    padding: 15px;\n}\n.easycommerce .easycommerce-permalink-input {\n    width: 190px;\n    padding: 5px 5px 5px 0;\n    border-top-width: 0;\n    border-left-width: 0;\n    border-right-width: 0;\n    border-bottom: 1px solid #d9d9d9;\n    border-radius: 0 !important;\n    line-height: 16px !important;\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-addnew_cat-input {\n    height: 48px;\n    border: 1px solid var(--color-ec-border) !important;\n    padding: 7px 20px !important;\n    font-size: 16px;\n    border-radius: 8px;\n}\n.easycommerce .easycommerce-addnew_cat-input:hover {\n    border: 1px solid var(--color-ec-secondary) !important;\n}\n.easycommerce .easycommerce-addnew_cat-input:focus {\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-secondary) !important;\n    border-color: var(--color-ec-primary) !important;\n    font-size: 16px;\n}\n.easycommerce .easycommerce-permalink-input:focus {\n    border-top-width: 0;\n    border-left-width: 0;\n    border-right-width: 0;\n    border-bottom: 1px solid #d9d9d9 !important;\n    border-radius: 0 !important;\n    box-shadow: none;\n}\n.easycommerce .easycommerce-input-checkoutbox {\n    position: relative;\n    margin: unset !important;\n    width: 20px;\n    height: 20px;\n    border-color: #7F7F98;\n    box-shadow: none;\n}\n\n.easycommerce .easycommerce-input-checkoutbox.easycommerce-thumbnail-checkbox {\n    width: 30px;\n}\n.easycommerce .easycommerce-input-checkoutbox:checked {\n    background-color: var(--color-ec-primary);\n    border: none;\n    box-shadow: none;\n}\n.easycommerce\n    .easycommerce-input-checkoutbox.easycommerce-thumbnail-checkbox:checked {\n    background-color: #009d68;\n    border: 1px solid #009d68;\n}\n.easycommerce .easycommerce-input-checkoutbox:focus {\n    box-shadow: none;\n    outline: none;\n    border-color: #7F7F98;\n}\n.easycommerce .easycommerce-input-checkoutbox:checked::before {\n    content: url(../../../../assets/admin/img/icons/checked.png);\n    margin: unset;\n    width: auto;\n    height: auto;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.easycommerce .easycommerce-parent-category-select {\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    line-height: 16px;\n    color: var(--color-ec-body);\n    padding: 16px;\n    background-color: #fff;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n}\n.easycommerce .easycommerce-parent-category-select:hover {\n    color: var(--color-ec-body);\n    border: 1px solid var(--color-ec-secondary);\n}\n.easycommerce .easycommerce-parent-category-select:focus {\n    color: var(--color-ec-body);\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-secondary) !important;\n    outline: none;\n}\n.easycommerce .easycommerce-attributes-row input {\n    border: none !important;\n    border-radius: 0;\n}\n.easycommerce .easycommerce-attributes-row input:focus {\n    box-shadow: none;\n    border-color: var(--color-ec-border);\n}\n.easycommerce .easycommerce-attributes-row .easycommerce-attribute-field {\n    border: 1px solid var(--color-ec-border) !important;\n    border-right: none !important;\n    padding: 15px;\n    border-radius: 4px 0 0 4px;\n    min-height: 56px;\n}\n.easycommerce-attributes-row button:hover svg path {\n    transition: 0.3s all ease;\n    fill: #ff3a52;\n}\n.easycommerce .easycommerce-attribute-item-cross-button:hover svg path {\n    fill: var(--color-ec-body);\n}\n.easycommerce-pricing-action-btn-details {\n    display: none;\n}\n.easycommerce-pricing-action-btn-details::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: -10px;\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid var(--color-ec-body);\n    clear: both;\n}\n.easycommerce-pricing-action-btn:hover\n    .easycommerce-pricing-action-btn-details {\n    transition: 0.3s all ease;\n    display: block;\n}\n.easycommerce-product-prices select {\n    width: 100%;\n    height: 48px;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n    color: var(--color-ec-placeholder);\n    font-size: 14px;\n    line-height: 20px;\n    font-family: \"Inter\", \"sans-serif\";\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce-product-prices select:hover {\n    color: var(--color-ec-body);\n    box-shadow: none;\n    outline: none;\n    border-color: var(--color-ec-body);\n}\n.easycommerce-product-prices select:focus {\n    color: var(--color-ec-body);\n    border-color: var(--color-ec-primary);\n    box-shadow: none;\n    outline: none;\n}\n.easycommerce-product-prices select:hover::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce-product-prices input {\n    border: 1px solid var(--color-ec-border);\n    border-radius: 4px;\n    padding: 10px;\n    color: var(--color-ec-body);\n    font-size: 16px;\n    font-family: \"Inter\", \"sans-serif\";\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce-product-prices input::placeholder {\n    color: var(--color-ec-placeholder);\n    font-size: 16px;\n}\n.easycommerce-product-prices input:focus {\n    box-shadow: none;\n    border-color: var(--color-ec-border);\n}\n.easycommerce-product-prices label input {\n    margin-left: 6px;\n}\n.easycommerce .easycommerce-physical-product-measurement-field {\n    display: flex;\n    border-radius: 8px;\n}\n.easycommerce .easycommerce-physical-product-measurement-field input {\n    border: none;\n    width: 100%;\n    min-height: 48px;\n    color: var(--color-ec-body);\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    background-color: transparent;\n}\n.easycommerce\n    .easycommerce-physical-product-measurement-field\n    input::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce .easycommerce-physical-product-measurement-field input:focus,\n.easycommerce .easycommerce-physical-product-measurement-field select:focus {\n    outline: none;\n    box-shadow: none;\n    border: none;\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-physical-product-measurement-field select:hover {\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-physical-product-measurement-field select {\n    width: 110px;\n    border: none;\n    font-size: 12px;\n    min-height: 48px;\n    border-left: 1px solid var(--color-ec-border);\n    background-color: transparent;\n}\n.easycommerce .easycommerce-physical-product-measurement-field select:focus {\n    border-left: 1px solid var(--color-ec-border);\n}\n.easycommerce .easycommerce-shipping select {\n    max-width: 100%;\n    min-height: 48px;\n    color: var(--color-ec-body);\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    border: 1px solid var(--color-ec-border);\n}\n.easycommerce .easycommerce-shipping select:focus {\n    border-color: var(--color-ec-border);\n    box-shadow: none;\n    outline: none;\n}\n.easycommerce .easycommerce-digital-product-meta-info input {\n    width: 70px;\n    height: 38px;\n    background: #f8f8f8;\n    border: 1px solid var(--color-ec-border);\n    padding: 6px 10px;\n    color: var(--color-ec-body);\n    line-height: 26px;\n    font-weight: 400;\n    font-size: 16px;\n}\n.easycommerce .easycommerce-digital-product-meta-info select {\n    width: 101px;\n    height: 38px;\n    background-color: #f8f8f8;\n    border: 1px solid var(--color-ec-border);\n    padding: 6px 10px;\n    color: var(--color-ec-body);\n    line-height: 26px;\n    font-weight: 400;\n    font-size: 16px;\n}\n.easycommerce .easycommerce-product-title {\n    width: 100%;\n    padding: 5px;\n    border-radius: 4px;\n    border: 2px dashed var(--color-ec-border);\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 26px;\n    font-family: \"Inter\", \"sans-serif\";\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-product-title::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce .easycommerce-input:focus {\n    border-color: var(--color-ec-border);\n    box-shadow: none;\n    outline: none;\n}\n.easycommerce .easycommerce-pricingplan-title-field {\n    width: calc(100% - 76px);\n    border: none !important;\n    padding: 10px 0;\n    font-size: 17px;\n    line-height: 26px;\n    font-weight: 600;\n    font-family: \"Inter\", \"sans-serif\";\n}\n.easycommerce .easycommerce-pricingplan-title-field::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce .easycommerce-choose-template-select-field {\n    max-width: 100%;\n    border: 1px solid var(--color-ec-border);\n    padding: 10px;\n    font-size: 16px;\n    line-height: 26px;\n    font-family: \"Inter\", \"sans-serif\";\n    color: var(--color-ec-placeholder);\n}\n.easycommerce .easycommerce-choose-template-select-field:focus {\n    border-color: var(--color-ec-border);\n    outline: 0;\n    box-shadow: none;\n    color: var(--color-ec-placeholder);\n}\n.easycommerce .easycommerce-choose-template-select-field:hover {\n    color: var(--color-ec-placeholder);\n}\n\n.easycommerce .easycommerce-switch {\n    position: relative;\n    display: inline-block;\n    width: 55px;\n    height: 25px;\n}\n\n.easycommerce .easycommerce-switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.easycommerce .easycommerce-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.easycommerce .easycommerce-slider:before {\n    position: absolute;\n    content: \"\";\n    height: 19px;\n    width: 19px;\n    left: 3px;\n    top: 3px;\n    background-color: white;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.easycommerce .easycommerce-switch input:checked + .easycommerce-slider {\n    background-color: #7351FD;\n}\n\n.easycommerce .easycommerce-switch input:checked + .easycommerce-slider:before {\n    -webkit-transform: translateX(30px);\n    -ms-transform: translateX(30px);\n    transform: translateX(30px);\n}\n.easycommerce\n    .easycommerce-product-gallery-image-delete\n    .easycommerce-image-delete-icon-default {\n    display: block;\n}\n.easycommerce\n    .easycommerce-product-gallery-image-delete\n    .easycommerce-image-delete-icon-hover {\n    display: none;\n}\n.easycommerce\n    .easycommerce-product-gallery-image-delete:hover\n    .easycommerce-image-delete-icon-default {\n    display: none;\n}\n.easycommerce\n    .easycommerce-product-gallery-image-delete:hover\n    .easycommerce-image-delete-icon-hover {\n    display: block;\n}\n\n/* Rounded sliders */\n.easycommerce .easycommerce-slider.easycommerce-round {\n    border-radius: 34px;\n}\n.easycommerce .easycommerce-slider.easycommerce-slider:before {\n    border-radius: 50%;\n}\n.easycommerce .mce-tinymce .mce-container-body .mce-edit-area iframe {\n    min-height: 450px !important;\n}\n.easycommerce .mce-tinymce .mce-container.mce-menubar.mce-toolbar.mce-first,\n.easycommerce\n    .mce-tinymce\n    .mce-branding.mce-widget.mce-label.mce-flow-layout-item.mce-last {\n    display: none !important;\n}\n\n/* Custom Input Fields Styles */\n.easycommerce .easycommerce-input-type-radio {\n    margin: 0;\n    border: 1px solid #dbdbdb;\n\n}\n.easycommerce .easycommerce-input-type-radio:checked,\n.easycommerce .easycommerce-input-type-radio.checked {\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: none;\n}\n.easycommerce .easycommerce-input-type-radio:checked::before,\n.easycommerce .easycommerce-input-type-radio.checked::before {\n    content: ' ';\n    background-color: var(--color-ec-primary);\n    border-radius: 50%;\n    width: .5rem;\n    height: .5rem;\n    margin: .1875rem;\n    line-height: 1.14285714;\n    float: left;\n    display: inline-block;\n    vertical-align: middle;\n}\n.easycommerce .easycommerce-input-type-select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n    color: var(--color-ec-body);\n    font-family: \"Inter\", \"sans-serif\";\n    font-size: 16px;\n    line-height: 26px;\n    box-shadow: none;\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce .easycommerce-input-type-select:hover {\n    border-color: var(--color-ec-secondary);\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-input-type-select::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce .easycommerce-input-type-select:focus {\n    color: var(--color-ec-body) !important;\n    border-color: var(--color-ec-primary);\n    outline: none;\n    box-shadow: none;\n}\n.easycommerce\n    .easycommerce-product-publish-data-and-time\n    .react-datepicker-wrapper {\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n}\n.easycommerce\n    .easycommerce-product-publish-data-and-time\n    .react-datepicker__input-container\n    input:first-child {\n    border: none;\n    position: relative;\n    z-index: 2;\n    background: transparent;\n    color: var(--color-ec-placeholder);\n    font-size: 14px;\n    line-height: 16px;\n    font-family: \"Inter\", \"sans-serif\";\n    padding-left: 10px;\n    padding-right: 40px;\n}\n.easycommerce\n    .easycommerce-product-publish-data-and-time\n    .react-datepicker__input-container::after {\n    position: absolute;\n    content: \"\";\n    top: 3px;\n    right: 10px;\n    width: 18px;\n    height: 21px;\n    background-image: url(../../../../assets/admin/img/icons/time.png);\n    z-index: 1;\n}\n.easycommerce .easycommerce-product-publish-data-and-time input:focus {\n    outline: none;\n    box-shadow: none;\n    border: none;\n}\n.easycommerce\n    .easycommerce-product-publish-data-and-time\n    input.react-datepicker-time__input {\n    border: 1px solid #000;\n    color: #000;\n}\n\n@media only screen and (max-width: 1280px) {\n    .easycommerce .easycommerce-switch {\n        width: 38px;\n        height: 20px;\n    }\n    .easycommerce .easycommerce-slider:before {\n        height: 15px;\n        width: 15px;\n    }\n    .easycommerce .easycommerce-switch input:checked + .easycommerce-slider:before {\n        transform: translateX(17px);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
